// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "root-1jMvX";
var _3 = "flight-I5qBy";
var _4 = "selected-GAAjb";
export { _1 as "__esModule", _2 as "root", _3 as "flight", _4 as "selected" }
export default { "__esModule": _1, "root": _2, "flight": _3, "selected": _4 }
